import { useState, useEffect, useCallback } from 'react';

const NICK_KEY = 'chatNickname';
const VISITOR_KEY = 'chatVisitorId';

function getOrCreateVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function validateNickname(nickname) {
  const trimmed = nickname.trim();
  if (trimmed.length < 3 || trimmed.length > 20) {
    return 'Nick musi mieć od 3 do 20 znaków';
  }
  if (!/^[a-zA-Z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ_.\- ]+$/.test(trimmed)) {
    return 'Nick może zawierać tylko litery, cyfry, spacje, kropki i myślniki';
  }
  if (trimmed.includes('@')) {
    return 'Nick nie może zawierać adresu e-mail';
  }
  return null;
}

export function validateMessage(text) {
  const trimmed = text.trim();
  if (!trimmed) return 'Wiadomość nie może być pusta';
  if (trimmed.length > 500) return 'Wiadomość może mieć maksymalnie 500 znaków';
  const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
  if (emailPattern.test(trimmed)) {
    return 'Nie wolno podawać adresów e-mail w wiadomościach';
  }
  return null;
}

export default function useChatNickname() {
  const [nickname, setNicknameState] = useState(() => localStorage.getItem(NICK_KEY) || '');
  const [visitorId] = useState(getOrCreateVisitorId);
  const [showNicknameModal, setShowNicknameModal] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(NICK_KEY)) {
      setShowNicknameModal(true);
    }
  }, []);

  const saveNickname = useCallback((newNick) => {
    const error = validateNickname(newNick);
    if (error) return error;
    const trimmed = newNick.trim();
    localStorage.setItem(NICK_KEY, trimmed);
    setNicknameState(trimmed);
    setShowNicknameModal(false);
    return null;
  }, []);

  return {
    nickname,
    visitorId,
    showNicknameModal,
    setShowNicknameModal,
    saveNickname,
    hasNickname: !!nickname,
  };
}
